
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.968.075h-6.38C.712.075.002.79.002 1.672v6.065c0 .882.71 1.597 1.586 1.597h6.38c.876 0 1.586-.715 1.586-1.597V1.672c0-.882-.71-1.597-1.586-1.597zM7.974 10.735h-6.38c-.876 0-1.586.715-1.586 1.597v6.065c0 .882.71 1.597 1.585 1.597h6.38c.876 0 1.586-.715 1.586-1.597v-6.065c0-.882-.71-1.597-1.585-1.597zM19.386 0h-6.38c-.876 0-1.586.715-1.586 1.596v6.066c0 .882.71 1.596 1.586 1.596h6.38c.876 0 1.585-.714 1.585-1.596V1.596c0-.881-.71-1.596-1.585-1.596zM19.411 10.723h-6.38c-.876 0-1.586.714-1.586 1.596v6.066c0 .881.71 1.596 1.586 1.596h6.38c.876 0 1.586-.715 1.586-1.596v-6.066c0-.882-.71-1.596-1.586-1.596z","fill":"#0E6199"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.554 5.223v2.508c0 .88-.712 1.596-1.586 1.596h-6.38A1.593 1.593 0 01.002 7.731V5.255a11.406 11.406 0 014.813-1.056c1.692 0 3.296.364 4.745 1.024h-.006z","fill":"#136FAD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.593 10.735h6.38c.875 0 1.586.717 1.586 1.597v6.065c0 .88-.711 1.597-1.585 1.597h-6.38a1.593 1.593 0 01-1.586-1.597v-6.065c0-.88.711-1.597 1.585-1.597z","fill":"#1B70A8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.33 9.258H13a1.593 1.593 0 01-1.586-1.596v-1.37a11.718 11.718 0 012.915 2.966zM13.031 10.723h2.141a11.643 11.643 0 011.162 5.085c0 1.47-.275 2.878-.768 4.173H13.03a1.593 1.593 0 01-1.586-1.596v-6.066c0-.88.712-1.596 1.586-1.596z","fill":"#136FAD"}})])
          )
        }
      }
    